import { http } from './httpClient';
import { AUTH_API } from './config';
import type { AuthUser } from '@/models/auth';

export const authService = {
  me: (accessToken: string) =>
    fetch(`${AUTH_API}/api/v1/auth/me`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    }).then(async (r) => (r.ok ? ((await r.json()) as AuthUser) : null)),

  refresh: (refresh_token: string) =>
    http<{ access_token: string; refresh_token: string; expires_in: number; user?: AuthUser }>(
      `${AUTH_API}/api/v1/auth/refresh`,
      {
        method: 'POST',
        body: JSON.stringify({ refresh_token }),
      },
      false
    ),

  authorizeUrl: async (redirect_uri: string) => {
    const r = await fetch(
      `${AUTH_API}/api/v1/auth/google/authorize?redirect_uri=${encodeURIComponent(redirect_uri)}`
    );
    if (!r.ok) throw new Error('Google login not available');
    const data = (await r.json()) as { url: string };
    return data.url;
  },

  exchangeCode: (code: string, redirect_uri: string) =>
    http<{
      access_token: string;
      refresh_token: string;
      expires_in: number;
      user: AuthUser;
    }>(
      `${AUTH_API}/api/v1/auth/google/callback`,
      {
        method: 'POST',
        body: JSON.stringify({ code, redirect_uri }),
      },
      false
    ),

  logout: (refresh_token: string) =>
    fetch(`${AUTH_API}/api/v1/auth/logout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token }),
    }).catch(() => {
      // best-effort
    }),
};
